import { TFunction } from "i18next";
import { Order } from "../../../core/models/entities/Order";
import { OrderShippingAgentMode } from "../../../data/models/bodies/OrderShippingBodies";

// Ret levering (flag REACT_APP_RET_LEVERING_ENABLED): derive the current
// delivery mode from the order. The API's OrderDto does not expose
// shippingService yet (built in parallel) - until it does, fall back to the
// deliveryBefore12PMwithGLS boolean the DTO has always carried, which
// distinguishes GLS12 from GLSNORM (pickup can only be detected once the
// service code arrives).
export function deriveDeliveryMode(order: Order): OrderShippingAgentMode {
  const service = order.shippingService?.trim().toUpperCase() ?? "";
  // The API persists the CONSIGNMENT SERVICE code on Order.ShippingService
  // (GLSNORM/GLS12/...). Pickup is the exception: its service code is blank,
  // so the API stores the AGENT code "AFHENT" instead (see
  // OrderShippingService.ChangeShippingAgentAsync fallback and
  // TrackingBackfillPolicy.PickupShippingService). "ALM"/PICKUP are kept as
  // belt-and-braces for legacy/NAV-sourced values.
  if (
    service === "ALM" ||
    service.includes("AFHENT") ||
    service.includes("PICKUP")
  )
    return "pickup";
  if (service.includes("GLS12")) return "gls12";
  if (service !== "") return "gls";
  return order.deliveryBefore12PMwithGLS ? "gls12" : "gls";
}

// Display text for the Delivery panel row. The internal carrier codes
// (AFHENT/GLSNORM/GLS12) are deliberately NOT shown - they are wire-data
// between KitMaker and NAV, not customer language (Nichlas 19/8).
export function deliveryModeLabel(
  t: TFunction,
  mode: OrderShippingAgentMode
): string {
  switch (mode) {
    case "pickup":
      return t("editDelivery.methodPickup");
    case "gls12":
      return t("editDelivery.methodGls12");
    default:
      return t("editDelivery.methodGls");
  }
}
